import * as tslib_1 from "tslib";
import { AngularFirestore } from "@angular/fire/firestore";
import { Events } from "@ionic/angular";
import algoliasearch from "algoliasearch";
import { environment } from "src/environments/environment";
import { SharedService } from "../shared/shared.service";
import { ConfigService } from "../config/config.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/fire/firestore";
import * as i2 from "@ionic/angular";
import * as i3 from "../shared/shared.service";
import * as i4 from "../config/config.service";
var SearchEngineService = /** @class */ (function () {
    function SearchEngineService(afs, events, sharedService, configService) {
        this.afs = afs;
        this.events = events;
        this.sharedService = sharedService;
        this.configService = configService;
        this.ALGOLIA_APP_ID = this.configService.environment.ALGOLIA_APP_ID;
        this.ALGOLIA_APP_KEY = this.configService.environment.ALGOLIA_APP_KEY;
        this.APP_PROJECT_ID = environment.firebase.projectId;
        this.page = 1;
        this.products = [];
        this.adminProducts = [];
        this.typesenseCred = this.configService.environment.typesense;
        this.useTypesense = this.configService.environment.useTypesense;
    }
    SearchEngineService.prototype.initializeSubscriptions = function () {
        var _this = this;
        this.events.subscribe("search-engine:alogoliaSearchProducts", function (searchValue, page, type) {
            _this.alogoliaSearchProducts(searchValue, page, type);
        });
        this.events.subscribe("search-engine:getProductsForSearchResults", function (searchValue, page, type) {
            _this.getProductsForSearchResults(searchValue, page, type);
        });
        if (this.typesenseCred && this.useTypesense) {
            this.typesenseClient = new Typesense.SearchClient({
                'nodes': [{
                        'host': this.typesenseCred.host,
                        'port': this.typesenseCred.port,
                        'protocol': this.typesenseCred.protocol
                    }],
                'apiKey': this.typesenseCred.searchOnlyKey,
                'connectionTimeoutSeconds': 2
            });
        }
    };
    SearchEngineService.prototype.alogoliaSearchProducts = function (searchValue, page, type) {
        if (page === void 0) { page = 0; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var searchRes;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        searchRes = { status: '', products: [] };
                        if (!this.useTypesense) return [3 /*break*/, 2];
                        console.log('useTypesense....');
                        return [4 /*yield*/, this.getSearchProductsFromTypesense(searchValue, page, type)];
                    case 1:
                        searchRes = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.getSearchProductsFromAlgolia(searchValue, page, type)];
                    case 3:
                        searchRes = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (searchRes.status === 'no_products') {
                            this.events.publish("search-engine:noSearchProductsAvailable");
                        }
                        else if (searchRes.status === 'no_more_products') {
                            this.events.publish("search-engine:noMoreSearchProducts");
                        }
                        else {
                            this.events.publish("search-engine:productSearchResults", searchRes.products);
                        }
                        this.saveAnalytics(searchValue);
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchEngineService.prototype.getProductsForSearchResults = function (searchValue, page, type) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var searchRes, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        searchRes = null;
                        if (!this.useTypesense) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getSearchProductsFromTypesense(searchValue, page, type)];
                    case 1:
                        searchRes = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.getSearchProductsFromAlgolia(searchValue, page, type)];
                    case 3:
                        searchRes = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (searchRes.status === 'no_products') {
                            this.events.publish("search-engine:noProductsForSearchResults");
                        }
                        else if (searchRes.status === 'no_more_products') {
                            this.events.publish("search-engine:noMoreProductsForSearchResults");
                        }
                        else {
                            this.events.publish("search-engine:publishProductForSearchResults", searchRes.products);
                        }
                        this.saveAnalytics(searchValue);
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        console.log(error_1);
                        this.events.publish("search-engine:noProductsForSearchResults");
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    SearchEngineService.prototype.getSearchProductsFromAlgolia = function (searchValue, page, type) {
        var _this = this;
        if (page === void 0) { page = 0; }
        return new Promise(function (resolve, reject) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var region, regionId, vendorId, filters, error_2;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (type === "new_search") {
                            this.products = [];
                        }
                        return [4 /*yield*/, this.sharedService.checkRegionIdForApi()];
                    case 1:
                        region = _a.sent();
                        regionId = region.regionId;
                        vendorId = region.vendorId;
                        filters = "status:true";
                        if (regionId) {
                            filters += " AND (categoryRegions:" + regionId + " OR brandRegions:" + regionId + ")";
                        }
                        if (vendorId) {
                            filters += " AND vendorId:" + vendorId;
                        }
                        this.client = algoliasearch(this.ALGOLIA_APP_ID, this.ALGOLIA_APP_KEY);
                        this.index = this.client.initIndex(this.APP_PROJECT_ID);
                        this.index
                            .search(searchValue, { page: page, filters: filters })
                            .then(function (result) {
                            // console.log(result);
                            if (result.nbPages === 0) {
                                resolve({ status: 'no_products', products: [] });
                            }
                            else if (result.hits.length === 0 && page === result.nbPages) {
                                resolve({ status: 'no_more_products', products: [] });
                            }
                            else {
                                result.hits.forEach(function (h) {
                                    _this.products.push(tslib_1.__assign({}, h, { id: h.objectID }));
                                });
                                resolve({ status: 'available', products: _this.products });
                            }
                        })
                            .catch(function (err) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                //console.log(err);
                                resolve({ status: 'no_products', products: [] });
                                return [2 /*return*/];
                            });
                        }); });
                        this.saveAnalytics(searchValue);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        //console.log(error);
                        resolve({ status: 'no_products', products: [] });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    SearchEngineService.prototype.getSearchProductsFromTypesense = function (searchValue, page, type, filterArg) {
        var _this = this;
        if (page === void 0) { page = 0; }
        return new Promise(function (resolve, reject) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var region, regionId, vendorId, filters, searchRequests, commonSearchParams;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (type === "new_search") {
                            this.products = [];
                        }
                        page += 1;
                        return [4 /*yield*/, this.sharedService.checkRegionIdForApi()];
                    case 1:
                        region = _a.sent();
                        regionId = region.regionId;
                        vendorId = region.vendorId;
                        filters = "status:=true";
                        if (vendorId) {
                            filters += " && vendorId:=" + vendorId;
                        }
                        searchRequests = {
                            'searches': [
                                {
                                    'collection': environment.firebase.projectId + "-products",
                                    'q': searchValue,
                                    'filter_by': filterArg || filters,
                                    'page': page,
                                    'per_page': 20
                                }
                            ]
                        };
                        if (regionId) {
                            searchRequests.searches[0].filter_by += " && categoryRegions:=" + regionId;
                            searchRequests.searches.push({
                                'collection': environment.firebase.projectId + "-products",
                                'q': searchValue,
                                'filter_by': (filterArg || filters) + " && brandRegions:=" + regionId,
                                'page': page,
                                'per_page': 20
                            });
                        }
                        commonSearchParams = {
                            'query_by': 'prodName, searchKeywords',
                        };
                        this.typesenseClient.multiSearch.perform(searchRequests, commonSearchParams).then(function (response) {
                            console.log(response);
                            if (!response || !response.results || !response.results.length) {
                                resolve({ status: 'no_products', products: [] });
                            }
                            else {
                                var noResults_1 = true;
                                var noMoreResults_1 = true;
                                response.results.forEach(function (result) {
                                    if (result.found > 0) {
                                        noResults_1 = false;
                                    }
                                    if (result.hits.length) {
                                        noMoreResults_1 = false;
                                    }
                                    result.hits.forEach(function (h) {
                                        if (!_this.products.length || _this.products.some(function (product) { return product.id !== h.document.id; })) {
                                            h.document = _this.parseArrayOfObjects(h.document);
                                            _this.products.push(tslib_1.__assign({}, h.document, { id: h.document.id, objectID: h.document.id }));
                                        }
                                    });
                                });
                                if (noResults_1) {
                                    console.log('noResults');
                                    resolve({ status: 'no_products', products: [] });
                                }
                                else if (noMoreResults_1) {
                                    console.log('noMoreResults');
                                    resolve({ status: 'no_more_products', products: [] });
                                }
                                else {
                                    console.log('available', _this.products);
                                    resolve({ status: 'available', products: _this.products });
                                }
                            }
                        }).catch(function (error) {
                            console.log(error);
                            resolve({ status: 'no_products', products: [] });
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    SearchEngineService.prototype.parseArrayOfObjects = function (object) {
        for (var key in object) {
            try {
                var value = JSON.parse(object[key]);
                if ((Array.isArray(value) && value.length && typeof value[0] == 'object') || (Array.isArray(value) && !value.length)) {
                    object[key] = value;
                }
            }
            catch (error) {
            }
        }
        return object;
    };
    SearchEngineService.prototype.saveAnalytics = function (value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var uid, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sharedService.getStorageUid()];
                    case 1:
                        uid = _a.sent();
                        if (uid) {
                            data = {
                                value: value,
                                searchedAt: new Date(),
                                source: "web",
                            };
                            this.afs
                                .collection("users")
                                .doc(uid)
                                .collection("analytics")
                                .doc("search")
                                .collection("data")
                                .add(data);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SearchEngineService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SearchEngineService_Factory() { return new SearchEngineService(i0.ɵɵinject(i1.AngularFirestore), i0.ɵɵinject(i2.Events), i0.ɵɵinject(i3.SharedService), i0.ɵɵinject(i4.ConfigService)); }, token: SearchEngineService, providedIn: "root" });
    return SearchEngineService;
}());
export { SearchEngineService };
